import React from 'react';

interface HowItWorksStepProps {
	number: number;
	description: React.ReactNode;
}
const HowItWorksStep: React.FC<HowItWorksStepProps> = ({ number, description }) => (
	<div className="step d-flex align-items-center">
		<div className="point-number bg-white rounded-circle d-flex align-items-center justify-content-center fw-semibold">
			{number}
		</div>
		<p className="text-white mb-0 flex-1">{description}</p>
	</div>
);

export default HowItWorksStep;
